const pad0 = x => x.toString().padStart(2, "0");

function toUTF8(body) {
    // convert from iso-8859-1 to utf-8
    return body;
    const ic = new iconv.Iconv('iso-8859-1', 'utf-8');
    const buf = ic.convert(body);
    return buf.toString('utf-8');
}

const convertDate = (timestamp) => {
    if (timestamp) {
        const a = (new Date(timestamp * 1000));
        return pad0(a.getDate()) + '/' +
            pad0(a.getMonth() + 1) + '/' +
            a.getFullYear() + " " +
            pad0(a.getHours()) + ":" +
            pad0(a.getMinutes());
    } else {
        return "";
    }
}

// const formatDate = (date, format) => {
//     if (date) {
//         let year = "";
//         let month = "";
//         let day = "";
//         let arr = date.split(/\/|-/);
//         if (arr[0].length === 4) {
//             year = arr[0];
//             month = arr[1];
//             day = arr[2];
//         } else {
//             day = arr[0];
//             month = arr[1];
//             year = arr[2];
//         }
//         if (format === 'yyyy-mm-dd') {
//             return year + "-" + pad0(month) + "-" + pad0(day);
//         } else {
//             return pad0(day) + "-" + pad0(month) + "-" + year;
//         }
//     } else {
//         return "";
//     }
// }

const formatDate = (date, format) => {
    let date_str = "";
    if (date) {
        let [date_format, time_format] = format.split(' ');
        date_format = date_format.toUpperCase();
        let [ddate, dtime] = date.split(' ');
        let year, month, day;

        let [d1, d2, d3] = ddate.split(/\/|-/);
        if (d1.length == 4) {
            year = d1;
            month = d2;
            day = d3;
        } else {
            year = d3;
            month = d2;
            day = d1;
        }

        if (date_format === 'YYYY-MM-DD' || date_format === 'Y-M-D') {
            date_str = year + "-" + pad0(month) + "-" + pad0(day);
        } else if (date_format === 'DD-MM-YYYY' || date_format === 'D-M-Y') {
            date_str = pad0(day) + "-" + pad0(month) + "-" + year;
        }

        if (time_format && dtime) {
            let [hour, minutes] = dtime.split(":");
            date_str += " " + pad0(hour) + ":" + pad0(minutes);
        }
    }
    return date_str;
}

const dateToSchedule = date => date ? date.split(/\/|-| |:/).join(".") : 0


const countSmsLength = (sms) => {
    let length = sms.length;
    // count €
    let doubleChars = (sms.match(/€/g) || []).length;

    return length + (doubleChars * 2);
}


// Return number of mobiles in string
const countMobiles = (mobiles) => {
    let count = 0;
    if (mobiles) {
        let arr = mobiles.split(/\r\n|\r|\n|,/);
        // remove empty elements
        arr = arr.filter(el => { return el != "" });
        count = arr.length;
        if (!arr[arr.length - 1]) count--;
        if (count == 0) count = 1;
    }
    return count;
}

const mobilesToArray = (mobiles) => {
    let arr = [];
    if (mobiles) {
        arr = mobiles.split(/\r\n|\r|\n|,/);
        // remove empty elements
        arr = arr.filter(element => { return element != "" });
    }
    return arr;
}

// Remove double entries from mobiles
const removeDoubleEntries = (mobiles) => {

    let uniq = [];
    let arr = [];
    if (mobiles) {
        arr = mobilesToArray(mobiles);
        uniq = [...new Set(arr)];
    }
}

// replace greek characters to latin
const convertMessage = (sms) => {
  	//sms = sms.toUpperCase();

 	let letters = [
 	    [ 'Α', 'A' ],
        [ 'Ά', 'A' ],
        [ 'Β', 'B' ],
        [ 'Ε', 'E' ],
        [ 'Έ', 'E' ],
        [ 'Ζ', 'Z' ],
        [ 'Η', 'H' ],
        [ 'Ή', 'H' ],
        [ 'Ι', 'I' ],
        [ 'Ί', 'I' ],
        [ 'Ϊ', 'I' ],
        [ 'Κ', 'K' ],
        [ 'Μ', 'M' ],
        [ 'Ν', 'N' ],
        [ 'Ο', 'O' ],
        [ 'Ό', 'O' ],
        [ 'Ρ', 'P' ],
        [ 'Τ', 'T' ],
        [ 'Υ', 'Y' ],
        [ 'Ύ', 'Y' ],
        [ 'Ϋ', 'Y' ],
        [ 'Χ', 'X' ],
        [ 'Ώ', 'Ω' ],
        [ '¶', 'A' ],

        [ 'α', 'A' ],
        [ 'ά', 'A' ],
        [ 'β', 'B' ],
        [ 'γ', 'Γ' ],
        [ 'δ', 'Δ' ],
        [ 'ε', 'E' ],
        [ 'έ', 'E' ],
        [ 'ζ', 'Z' ],
        [ 'η', 'H' ],
        [ 'ή', 'H' ],
        [ 'θ', 'Θ' ],
        [ 'ι', 'I' ],
        [ 'ί', 'I' ],
        [ 'ϊ', 'I' ],
        [ 'κ', 'K' ],
        [ 'λ', 'Λ' ],
        [ 'μ', 'M' ],
        [ 'ν', 'N' ],
        [ 'ξ', 'Ξ' ],
        [ 'ο', 'O' ],
        [ 'ό', 'O' ],
        [ 'π', 'Π' ],
        [ 'ρ', 'P' ],
        [ 'σ', 'Σ' ],
        [ 'ς', 'Σ' ],
        [ 'τ', 'T' ],
        [ 'υ', 'Y' ],
        [ 'ύ', 'Y' ],
        [ 'ϋ', 'Y' ],
        [ 'φ', 'Φ' ],
        [ 'χ', 'X' ],
        [ 'ψ', 'Ψ' ],
        [ 'ω', 'Ω' ],
        [ 'ώ', 'Ω' ],
        [ '¶', 'A' ],

    ];

 	letters.map( letter => {
        sms = sms.replace(new RegExp(letter[0], 'g'), letter[1]);
    });

    return sms;
}

const JSONClone = ob => {
    return JSON.parse(JSON.stringify(ob));
}

const generateApiKey = () => {
    let d = new Date().getTime();

	if( window.performance && typeof window.performance.now === "function" ) {
		d+= performance.now();
	}

	let key = 'xxxx-xxxx-yxxx-xxxxxxx'.replace(/[xy]/g, function(c) {
		let r = (d + Math.random()*16)%16 | 0;
		d = Math.floor(d/16);
		return (c === 'x' ? r : (r&0x3|0x8)).toString(16);
	});

    return key;
}

// set the focus on specific control
const setFocusTo = (element_id, immediate = false) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, immediate ? 1 : 280);
    }
}

export {
    convertDate,
    formatDate,
    dateToSchedule,
    toUTF8,
    countSmsLength,
    countMobiles,
    removeDoubleEntries,
    convertMessage,
    JSONClone,
    generateApiKey,
    setFocusTo,
};